import { CommunicationIdentityTokenResponse } from "@veris-health/communication-ms/lib/v1";
import { voipApiV1 } from "../../../api";

export const fetchVoipUserAccessToken = async (
  id: number,
): Promise<CommunicationIdentityTokenResponse> => {
  const response = await voipApiV1.getVoipToken(id);
  return response.data;
};
